import React from 'react'
import Header from './components/Header/Header'
import Hero from './components/Hero/Hero'
import MenuSection from './components/MenuSection/MenuSection'
import LocationSection from './components/LocationSection/LocationSection'
// import EventsSection from './components/EventsSection/EventsSection'
import StorySection from './components/StorySection/StorySection'
import SocialSection from './components/SocialSection/SocialSection'
import Footer from './components/Footer/Footer'
import './App.css'

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <MenuSection />
      <LocationSection />
      <StorySection />
      <SocialSection />
      <Footer />
    </div>
  )
}

export default App
